export enum ModuleFeatureSwitchName {
    Attendance = 'attendance',
    ParticipantTab = 'participant_tab',
    ScheduleTab = 'schedule_tab',
    PersonalDocuments = 'personal_documents',
    CollaborationTab = 'collaboration_tab',
    PasswordlessLogin = 'passwordless_login',
    CourseSelfCancellation = 'course_self_cancellation',
    ContentTab = 'content_tab',
    ManagerFiles = 'manager_files',
    PersonalDocumentsCopyrightProtection = 'personal_documents_copyright_protection',
    OverviewTab = 'overview_tab',
}
